import { DISTRIBUIDOR, FABRICANTE, IMPORTADOR, UJ } from 'utils/constants/reach_role';

import Joi from '@hapi/joi';

const baseProperties = ['code', 'trade_name', 'supplier_id', 'sds_date', 'sds_revision', 'reach_role'];

export const schema = Joi.object({
  code: Joi.string()
    .min(3)
    .max(60)
    .required()
    .messages({
      "any.required": `"Código" campo de preenchimento obrigatório`,
      "string.empty": `"Código" campo vazio`,
      "string.min": `"Código" tem de ter pelo menos 3 caracteres`,
      "string.max": `"Código" só pode 60 caracteres máximo`
    }),
  trade_name: Joi.string()
    .min(3)
    .max(200)
    .required()
    .messages({
      "any.required": `"Designação Comercial" campo de preenchimento obrigatório`,
      "string.empty": `"Designação Comercial" campo vazio`,
      "string.min": `"Designação Comercial" tem de ter pelo menos 3 caracteres`,
      "string.max": `"Designação Comercial" só pode 200 caracteres máximo`
    }),
  supplier_id: Joi.number()
    .required()
    .messages({
      "any.required": `"Fornecedor" campo de preenchimento obrigatório`,
      "number.base": `"Fornecedor tem de ser um identificador numérico"`
    }),

  sds_date: Joi.date()
    .allow(null)
    .messages({
      "any.required": `"Data FDS" campo de preenchimento obrigatório`,
      "date.base": `"Data FDS" tem de ser uma data válida"`
    }),
  sds_revision: Joi.string()
    .max(25)
    .allow('')
    .allow(null)
    .messages({
      "any.required": `"Revisão FDS" campo de preenchimento obrigatório`,
      "string.empty": `"Revisão FDS" campo vazio`,
      "string.max": `"Revisão FDS" só pode 25 caracteres máximo`
    }),
  reach_role: Joi.string()
    .valid(UJ, FABRICANTE, IMPORTADOR, DISTRIBUIDOR)
    .required()
    .messages({
      "any.required": `"Papel Reach" campo de preenchimento obrigatório`,
      "string.empty": `"Papel Reach" campo vazio`,
      "any.only": `"Papel Reach" só pode ter as seguintes opções: UJ, Fabricante, Importador ou Distribuidor`,
      "string.valid": `"Papel Reach" só pode ter as seguintes opções: UJ, Fabricante, Importador ou Distribuidor`
    })
});

/**
 * ⚠️ `shipmentsOfRawMaterial` is `shipmentsByRawMaterial(state)` from
 * `selectors/generic` - the shipments of a raw material, which used to arrive
 * on the raw material itself as `raw_material_suppliers`. It is walked in the
 * order of `rawMaterials` so the raw material named in the error message is
 * still the first one holding the repeated code.
 */
export const validator = (newEntity, rawMaterials, shipmentsOfRawMaterial) => {
  let iEntity = { ...newEntity };

  Object.keys(iEntity).forEach(k => {
    if (!baseProperties.includes(k)) {
      delete iEntity[k];
    }
  });
  // Validate data correctness
  const validateEntity = schema.validate(iEntity, { abortEarly: false });
  if (validateEntity.error) {
    return { error: validateEntity.error.details.map(obj => obj.message) };
  }

  // Validate repetitions code shipment
  const codeRepeatedRM = rawMaterials.find(rm => {
    const shipments = shipmentsOfRawMaterial[rm.id] || [];
    if (shipments.length > 0) {
      return shipments.some(sh =>
        sh.code === newEntity.code && sh.id !== newEntity.id
      );
    }
    return false;
  });

  if (codeRepeatedRM) {
    return {
      error: [
        'Codigo de fornecimento repetido',
        `A Matéria Prima [Nome: ${codeRepeatedRM.name}, Codigo MP: ${codeRepeatedRM.code}] já possui um fornecimento com o mesmo código`
      ]
    };
  }

  return iEntity;
};

